import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SeoContentSection from './components/SeoContentSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategorySection />
      <SeoContentSection />
      <SiteFooter />
    </main>
  );
}